import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

export const fetchSettings = async () => {
  const { data } = await api.get('/settings');
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await api.post('/orders', payload);
  return data;
};

export const createLead = async (payload) => {
  const { data } = await api.post('/leads', payload);
  return data;
};
